import { createStyles, Theme } from "@material-ui/core";
export const userStyles = (theme: Theme) =>
  createStyles({
    saveDialogContainer: {
      "& .paraDetails": {
        marginLeft: "auto",
        marginRight: "auto",
        width: "30em",
        padding: "12px 30",
      },
      "& p": {
        fontSize: 16,
        fontWeight: 400,
        padding: "14px 0px 26px",
        color: "#333",
        lineHeight: "22px",
      },
      "& button": {
        width: 175,
        margin: "10px 0px 16px",
      },
    },
    editLockedPopUp: {
      textAlign: "center",
      "& h2": {
        color: "#333",
        fontWeight: 600,
        fontSize: 24,
        lineHeight: "34px",
      },
      "& p": {
        color: "#666",
        fontSize: 16,
      },
      '& button':{
        background: '#1D7DEA',
        borderRadius: 4,
        color: '#fff',
        margin: '11px 0',
        lineHeight: '44px',
        height: 44,
        fontWeight: 500,
        "&:hover":{
          background: '#1D7DEA',
          color: '#fff',
        }
      },
    },
    closeIcon:{
      '& svg':{
      position: 'absolute',
      right: 20,
      top: 0,
      transform: 'scale(1.4)',
      cursor: 'pointer',
      opacity: 0.5,
    }
  },
    editLockedPopUp1:{
      paddingBottom: 40,
    }
  });
